import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { GeneralService } from '@core/http/general/general.service';
import { DirectPaymentMethods } from '@app/core/enums/direct-payment-methods';
import { untilDestroyed } from '@ngneat/until-destroy';
import { IReqPay } from '@app/core/http/general/general.interface';
import { AppPayService } from '@app/shared/services/app-pay.service';

@Component({
  selector: 'app-init',
  templateUrl: './init.component.html',
})
export class InitComponent implements OnInit, OnDestroy {
  constructor(
    private deviceService: DeviceDetectorService,
    private router: Router,
    private route: ActivatedRoute,
    private generalService: GeneralService,
    private appPayService: AppPayService
  ) {}

  isLoading = false;
  isRedirect = false;
  info: any | null = null;
  directPaymentMethods: typeof DirectPaymentMethods = DirectPaymentMethods;
  paymentMethod: any | null = null;
  ngOnInit() {
    this.isLoading = true;
    const init = this.generalService.initialize(this.route);
    if (init) {
      this.generalService
        .getTransactionInfo()
        .pipe(untilDestroyed(this))
        .subscribe((info) => {
          if (!info) {
            return;
          }
          this.info = info;
          this.paymentMethod = info.defaultPaymentMethod;
          if (info.defaultPaymentMethod === 'APP_PAY') {
            const req = { pspCode: 'APP_PAY', email: info.email };
            this.generalService
              .checkMobilePayAvailability(req)
              .pipe(untilDestroyed(this))
              .subscribe((response) => {
                if (response.hasMobilepayCheckout) {
                  // Store the response data in the service
                  // const [gatewayMerchantId, merchantId, merchantName,googleActive,
                  //   appleActive] =
                  //   response.gatewayMerchantId.split('-');
                  // const appPayData = {
                  //   gatewayMerchantId,
                  //   merchantId,
                  //   merchantName,
                  //   googleActive,
                  //   appleActive
                  // };
                  // this.appPayService.setMobilePayData(appPayData);
                  this.router.navigate(['payment-methods/mobile-pay']);
                }
                else{
                  this.handlePayment();
                }
              }); 
          }
          else{
            this.handlePayment();
          }
        }); 
    }}

  

        
          
handlePayment(){
  const currency = this.info.currency;

 
   // CRYPTO to CCCRYPTO
   if (this.info.defaultPaymentMethod === 'CRYPTO') {
    this.paymentMethod = 'CCCRYPTO';
  }

  if (this.paymentMethod === 'UNDETERMINED') {
    this.router.navigate(['payment-methods']);
  } else {
    const types = Object.keys(this.directPaymentMethods).indexOf(
      this.paymentMethod
    );
    if (
      types !== -1 ||
      (this.paymentMethod === 'BTVOUCHER' &&
        currency !== 'TRY' &&
        currency !== 'USD')
    ) {
      this.isRedirect = true;
      const request: IReqPay = {
        account: {},
        customerInfo: {
          ip: JSON.parse(localStorage.getItem('transaction'))['ip'],
          agent: this.deviceService.getDeviceInfo().userAgent,
        },
        paymentMethod:this.paymentMethod,
      };
      // Community bank FE-1500 FE=1714
      if (
        this.paymentMethod === 'COMMUNITY_BANK' ||
        this.paymentMethod === 'PAPARAC' ||
        this.paymentMethod === 'PEPPARAC'
      ) {
        const communityBank: any = JSON.parse(
          localStorage.getItem('communityBank')
        );
        request.account.bankCode = communityBank.bankCode;
        request.activeAmountId = communityBank.activeAmountId;
      }
      this.generalService
        .pay(request)
        .pipe(untilDestroyed(this))
        .subscribe((response) => {
          if (response && response.redirectUrl) {
            window.location.href = response.redirectUrl;
          }
        });
    } else {
      const view = this.paymentMethod.toLowerCase().split('_').join('-');
      this.router.navigate(['payment-methods/' + view]);
    }
  }
}
   



  ngOnDestroy() {}
}
